import { Grid, Stack, TextField, Autocomplete, InputAdornment } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import axios from "axios";
import { ReactNode, useEffect, useRef, useState } from "react";
import { BlacklistNameEntity } from "./types";

type ReviewFieldHoverProps = { onMouseEnter: () => void; onMouseLeave: () => void };

interface Props {
  entityInfo: BlacklistNameEntity;
  changeEntityInfo: (e: any, value: any) => void;
  error: boolean;
  onBlurEntity: () => void;
  isEditMode?: boolean;
  disabled?: boolean;
  renderReviewActions?: (fieldId: string, displayedValue: unknown) => ReactNode;
  getReviewFieldHoverProps?: (fieldId: string) => ReviewFieldHoverProps;
  getReviewFieldHighlightSx?: (fieldId: string) => SxProps<Theme>;
}
export default function EntityContactInfo(props: Props) {
  const [companyTypes, setCompanyTypes] = useState<any[]>([]);
  const locked = useRef(props.entityInfo);
  const ro = (val: any) => Boolean(props.disabled) || (props.isEditMode && Boolean(val));

  const getCompanyTypes = async () => {
    const { data } = await axios.get("/api/blacklist/getCompanyTypes");
    setCompanyTypes(data);
  };

  useEffect(() => {
    getCompanyTypes();
  }, []);
  return (
    <>
      <Stack direction="row" justifyContent="space-between" marginTop="40px">
        <Grid item md={6} xs={12} spacing={2}>
          <TextField
            label="Company Name"
            value={props.entityInfo.name}
            {...props.getReviewFieldHoverProps?.("companyName")}
            sx={props.getReviewFieldHighlightSx?.("companyName")}
            onChange={(e) => props.changeEntityInfo("name", e.target.value)}
            fullWidth
            error={props.error}
            onBlur={props.onBlurEntity}
            disabled={Boolean(props.entityInfo.lookupCode) || ro(locked.current?.name)}
            InputProps={{
              endAdornment: props.renderReviewActions ? (
                <InputAdornment position="end">{props.renderReviewActions("companyName", props.entityInfo.name)}</InputAdornment>
              ) : undefined
            }}
          />
        </Grid>
        <Grid item md={6} xs={12} marginLeft={2}>
          <Autocomplete
            options={companyTypes || []}
            getOptionLabel={(option) => option.name || ""}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Company Type(LLC, Corp, etc)"
                {...props.getReviewFieldHoverProps?.("companyTypeId")}
                sx={props.getReviewFieldHighlightSx?.("companyTypeId")}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {props.renderReviewActions && (
                        <InputAdornment position="end">
                          {props.renderReviewActions("companyTypeId", props.entityInfo.companyTypeId?.label || "")}
                        </InputAdornment>
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }}
              />
            )}
            onChange={(e, value) => props.changeEntityInfo("companyTypeId", value)}
            value={props.entityInfo.companyTypeId || null}
            disabled={ro(locked.current?.companyTypeId?.value)}
          />
        </Grid>
      </Stack>
      <Grid item md={6} xs={12} marginTop={4}>
        <TextField
          label="Tax ID"
          value={props.entityInfo.taxID}
          {...props.getReviewFieldHoverProps?.("taxId")}
          sx={props.getReviewFieldHighlightSx?.("taxId")}
          onChange={(e) => props.changeEntityInfo("taxID", e.target.value)}
          fullWidth
          disabled={ro(locked.current?.taxID)}
          InputProps={{
            endAdornment: props.renderReviewActions ? (
              <InputAdornment position="end">{props.renderReviewActions("taxId", props.entityInfo.taxID)}</InputAdornment>
            ) : undefined
          }}
        />
      </Grid>
    </>
  );
}
